import * as schemas from '@tunein/reporting-schemas-legacy';
import { mapValues } from 'es-toolkit';
import { Validator } from '../Validator';
export const tuneInEventValidators = mapValues(schemas, (schema) => {
    const defName = schema.$ref.split('/').pop();
    const eventName = schema.$defs[defName].properties.event.enum[0];
    return new Validator(schema, eventName);
});
